import { render } from "./DetalleCotizacionView.vue?vue&type=template&id=7c3b1e8e"
import script from "./DetalleCotizacionView.vue?vue&type=script&lang=js"
export * from "./DetalleCotizacionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__